// frontend/src/config/api.js
import axiosInstance from "../axiosConfig";

// Re-exportar la instancia configurada
export default axiosInstance;

// Exportar API_BASE_URL desde axiosConfig
export { API_BASE_URL } from "../axiosConfig";

// URL base para archivos (comprovantes, avatares, etc)
export const getStorageUrl = (path) => {
  if (!path) return null;
  
  // Si ya es una URL completa, devolverla
  if (path.startsWith('http')) return path;
  
  // Para archivos locales
  const isProduction = process.env.NODE_ENV === 'production';
  const baseUrl = isProduction 
    ? 'https://brechovizinho.com.br'
    : 'http://localhost:8000';
  
  // 🔥 CORREGIDO: Detectar si es banner o archivo
  if (path.includes('banners')) {
    return `${baseUrl}/storage/${path}`;
  }
  
  // Extraer solo el nombre del archivo
  let filename = path.split('/').pop();
  return `${baseUrl}/api/file/${filename}`;
};

// 🔥 ACTUALIZADO: Ya no es necesario enviar Authorization manual
export const getAuthHeaders = () => {
  return {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  };
};

// Helper para verificar si el usuario está autenticado
export const isAuthenticated = () => {
  // Verificar si hay un usuario en localStorage
  const user = localStorage.getItem("user");
  return !!user;
};

// Helper para obtener el usuario actual
export const getCurrentUser = () => {
  const userStr = localStorage.getItem("user");
  if (!userStr) return null;
  try {
    return JSON.parse(userStr);
  } catch {
    return null;
  }
};